module.exports = __webpack_public_path__ + "img/t4-i25.3ec70993.jpg";